import React, { useMemo, useState } from 'react';
import SectionDivider from '../SectionDivider/SectionDivider';
import './CompatibleLenses.scss';
import Section from '../Section/Section';
import { replaceImageURL } from '../helper';
import { useSelector } from 'react-redux';
import { v4 } from 'uuid';

const TechnicalDetails = ({ thumbnailImage, isAccessories }) => {
  const localeInfo = useSelector(state => state.common.localeInfo);
  const pid = useSelector(state => state.common.productID);
  const dataLocale = useSelector(state => state.locale);

  const {
    COMPATIBLE_LENSES_ONLINE_STORE,
    LENSES_BLUE_LIGHT,
    COLOUR_LENSES,
    HIGH_INDEX_ASPHERIC_LENSES,
    TRANSITIONS_LENSES,
    TRANSITIOND_LIGHT_INTELLIGENT_LENSES,
    MORE_DETAILS,
    PLEASE_NOTE_PROGRESSIVE_GLASSES_NOT_AVAILABLE_FOR_PURCHASE,
  } = dataLocale;

  const [isCollapsed, setIsCollapsed] = useState(false);

  const compatibleLensesButtons = useMemo(() => {
    return [
      {
        title: LENSES_BLUE_LIGHT,
        href: '#',
      },
      {
        title: COLOUR_LENSES,
        href: '#',
      },
      {
        title: HIGH_INDEX_ASPHERIC_LENSES,
        href: '#',
      },
      {
        title: TRANSITIONS_LENSES,
        href: '#',
      },
      {
        title: TRANSITIOND_LIGHT_INTELLIGENT_LENSES,
        href: '#',
      },
    ];
  }, [
    COLOUR_LENSES,
    HIGH_INDEX_ASPHERIC_LENSES,
    LENSES_BLUE_LIGHT,
    TRANSITIOND_LIGHT_INTELLIGENT_LENSES,
    TRANSITIONS_LENSES,
  ]);

  const handleCompatibleLensesClick = link => {
    window.location.assign(link);
  };

  return (
    <div className={`compatible-lenses ${isAccessories ? 'hidden' : ''}`}>
      <div className="main-content-wrapper">
        <Section style={{ margin: 0 }}>
          <SectionDivider
            collapsible
            handleToggleCollapse={() => setIsCollapsed(!isCollapsed)}
            isCollapsed={isCollapsed}
            sectionName={COMPATIBLE_LENSES_ONLINE_STORE}
          />
          <div
            className={`compatible-lenses__collapsible ${
              isCollapsed && 'compatible-lenses__collapsible--collapsed'
            }`}
          >
            <div
              className={`compatible-lenses__layout ${
                isCollapsed && 'compatible-lenses__layout--collapsed'
              }`}
            >
              <div>
                <div className="compatible-lenses__buttons">
                  {compatibleLensesButtons.map(el => {
                    return (
                      <span key={v4()} className="compatible-lenses__button od-font-bold">
                        {el.title}
                      </span>
                    );
                  })}
                </div>
                <div
                  className="compatible-lenses__more-detals od-font-bold"
                  onClick={() => handleCompatibleLensesClick('/sg/en/services/lens')}
                >
                  {MORE_DETAILS}
                </div>
                <ul className="compatible-lenses__points od-font-reg">
                  <li className="compatible-lenses__point">
                    {PLEASE_NOTE_PROGRESSIVE_GLASSES_NOT_AVAILABLE_FOR_PURCHASE}
                  </li>
                </ul>
              </div>
              <div className="compatible-lenses__thumbnail">
                <img
                  alt={COMPATIBLE_LENSES_ONLINE_STORE.toLowerCase()}
                  className="compatible-lenses__thumbnail__img"
                  src={replaceImageURL(thumbnailImage, localeInfo, pid)}
                />
              </div>
            </div>
          </div>
        </Section>
      </div>
    </div>
  );
};

export default TechnicalDetails;
